// https://vuex.vuejs.org/en/getters.html

export default {
  catalogs(state) {
    return state.catalogs;
  },
  errors(state) {
    return state.errors;
  },
  loading(state) {
    return state.loading;
  },
  totalCount(state) {
    return state.totalCount;
  }
};
